import { faCoffee, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, SvgIcon, Icon, colors, Tooltip } from '@mui/material';
import React from 'react';
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const formato = {
    cantidad: '0.000000',
    money: '$0.00'
};

const ExportExcel = (props) => {
    const { id, data, columns, fileName, tipoReporte, exportar } = props;
    const multiDataSet = [
        {
            columns: columns.map((col) => ({ title: col.label, width: { wpx: 80 } })),
            data: data.map((row) =>
                columns.map((col) => ({
                    value: ['money', 'cantidad'].includes(col.type) ? Number(row[col.name]) || 0 : row[col.name] || '',
                    style: {
                        numFmt: formato[col.type]
                    }
                }))
            )
        }
    ];

    return (
        <ExcelFile
            filename={fileName}
            element={
                <Tooltip title="Exportar Excel">
                    <Button id={id} variant="contained" className="btnExcel" color="blue" size="small">
                        <Icon color="white" component={FontAwesomeIcon} icon={faFileExcel} style={{ color: 'white' }} />
                    </Button>
                </Tooltip>
            }
        >
            <ExcelSheet dataSet={multiDataSet} name="Organization" />
        </ExcelFile>
    );
};

export default ExportExcel;
